import React from "react";
import Slider from "react-slick";

// import arrowLeft from "../../../resources/images/arrow-left.svg";
// import arrowRight from "../../../resources/images/arrow-right-carousel.svg";

import ComponentTitle from "../../../components/ComponentTitle/ComponentTitle";

import {
  StyledMainContainer,
  StyledTitleContainer,
} from "./CaseStudiesMobilestyle";

import {
  FinancialServiceSvg,
  GamblingSvg,
  HealthyCareSvg,
  MobilityAndTravelSvg,
  RetailAndCommerceSvg,
  SharingEconomySvg,
  TeleCommunicationSvg,
  EducationSvg,
} from "../../../resources/SvgComponents/CaseStudies";

import CaseStudiesMain from "./components/CaseStudiesMain";

// function SampleNextArrow(props) {
//   const { onClick } = props;
//   return (
//     <StyledRightArrowBtn onClick={onClick}>
//       <img src={arrowRight} alt="" />
//     </StyledRightArrowBtn>
//   );
// }

// function SamplePrevArrow(props) {
//   const { onClick } = props;
//   return (
//     <StyledLeftArrowBtn onClick={onClick}>
//       <img src={arrowLeft} alt="" />
//     </StyledLeftArrowBtn>
//   );
// }

const CaseStudiesMobile = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
  };

  return (
    <StyledMainContainer>
      <StyledTitleContainer>
        <ComponentTitle value="useCasesTitle" />
      </StyledTitleContainer>
      <Slider {...settings}>
        <CaseStudiesMain
          title="financialService"
          description="financialServiceDescription"
          effectText="financialServiceEffect"
          image={<FinancialServiceSvg />}
        />
        <CaseStudiesMain
          title="gambling"
          description="gamblingDescription"
          effectText="gamblingEffect"
          image={<GamblingSvg />}
        />
        <CaseStudiesMain
          title="teleCommunication"
          description="teleCommunicationDescription"
          effectText="gamblingEffect"
          image={<TeleCommunicationSvg />}
        />
        <CaseStudiesMain
          title="retailAndCommerce"
          description="retailAndCommerceDescription"
          effectText="financialServiceEffect"
          image={<RetailAndCommerceSvg />}
        />
        <CaseStudiesMain
          title="sharingEconomy"
          description="sharingEconomyDescription"
          effectText="financialServiceEffect"
          image={<SharingEconomySvg />}
        />
        <CaseStudiesMain
          title="education"
          description="educationDescription"
          effectText="financialServiceEffect"
          image={<EducationSvg />}
        />
        <CaseStudiesMain
          title="mobilityAndTravel"
          description="mobilityAndTravelDescription"
          effectText="financialServiceEffect"
          image={<MobilityAndTravelSvg />}
        />
        <CaseStudiesMain
          title="healthyCare"
          description="healthyCareDescription"
          effectText="financialServiceEffect"
          image={<HealthyCareSvg />}
        />
      </Slider>
    </StyledMainContainer>
  );
};

export default CaseStudiesMobile;
